import { Component, inject, OnInit } from '@angular/core';
import { BlogService } from '../../services/posts/posts-v2.service';
import { InnerContentComponent } from '../../components/inner-content/inner-content.component';
import { IPost } from '../../services/posts/post.interface';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PageBlockframeComponent } from '../../components/page-blockframe/page-blockframe.component';
import {
    APOLLO_FETCH_ERROR,
    POST_NOT_FOUND_ERROR,
} from '../../shared/constants/error.constants';
import { ErrorModule } from '../../components/error/error.module';

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss'],
    imports: [
        InnerContentComponent,
        DatePipe,
        PageBlockframeComponent,
        AsyncPipe,
        ErrorModule,
    ],
})
export class AnnouncementsComponent implements OnInit {
    public headerImage = 'assets/images/Whats-New-128x82-v2.png';
    public posts: IPost[] = [];
    private allPost: IPost[] = [];
    public error: string | null = null;

    private readonly blogService = inject(BlogService);
    private readonly route = inject(ActivatedRoute);

    get loading$() {
        return this.blogService.loading$;
    }

    ngOnInit(): void {
        this.blogService.getPosts$('Announcement').subscribe({
            next: (posts: any) => {
                this.allPost = posts;
                this.posts = this.allPost;
                this.setPosts(this.route.snapshot.params['slug']);
            },
            error: (err: any) => {
                console.error('Error fetching posts:', err);
                this.error = APOLLO_FETCH_ERROR;
            },
        });

        this.route.params.subscribe((params: any) => {
            this.setPosts(params['slug']);
        });
    }

    setPosts(slug: string) {
        if (this.allPost.length === 0) {
            this.posts = [];
            this.error = null;
            return;
        }

        if (slug) {
            const match = this.allPost.find((post) => post.slug === slug);
            this.posts = match ? [match] : [];
            this.error = match ? null : POST_NOT_FOUND_ERROR;
        } else {
            this.posts = this.allPost;
            this.error = null;
        }
    }
}
